import {register} from "../../../JavaScript/Utils";

export const ModalHotlineOverlay = (el: HTMLElement) => {
  const closeButtonModalBox = el.querySelector('.js_modal-close')
  const body = document.querySelector("body");
  const cookieName = 'ModalboxInfo=true;';
  const cookieEnabled = document.cookie.indexOf('ModalboxInfo') != -1;

  const openModal = () => {
    el.classList.add("is--active");

    if (body) {
      body.style.overflow = "hidden";
    }
  }

  const setCookie = () => {
    const now = new Date();
    const expire = new Date();
    expire.setFullYear(now.getFullYear());
    expire.setMonth(now.getMonth());
    expire.setDate(now.getDate()+1);
    expire.setHours(0);
    expire.setMinutes(0);
    document.cookie = cookieName + "expires=" + expire.toString() +"; path=/";
  }

  const closeModal = () => {
    el.classList.remove("is--active");

    if (body) {
      body.style.overflow = "visible";
    }
  }

  if (!cookieEnabled) {
    openModal();

    closeButtonModalBox.addEventListener("click", () => {
      setCookie();
      closeModal();
    });
  }
};

register("ModalHotlineOverlay", ModalHotlineOverlay);
